import React, { useEffect } from "react";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";

import LoginPage from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ReferenceValuesPage from "./pages/ReferenceValues";
import ChangePasswordPage from "./pages/ChangePassword";
import { clearSession, tokenExpired } from "./util/auth";

const Guarded: React.FC = () => {
  if (tokenExpired()) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

const App: React.FC = () => {
  useEffect(() => {
    if (tokenExpired() && window.location.pathname !== "/login") {
      clearSession();
      window.location.href = "/login";
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route element={<Guarded />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/ref-values" element={<ReferenceValuesPage />} />
          <Route path="/change-password" element={<ChangePasswordPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
